<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Head Drip Colour';
                }
            },
            component_id: {
                default(){
                    return 'head_drip_colour';
                }
            },
            frameProfile: {
                required: true
            },
            openingDirection: {
                required: true,
            },
            doorRange: {
                required: false,
                default() {
                    return 0;
                }
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameProfile, this.openingDirection, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/head-drip-colour?profile=' + this.frameProfile + '&opening_direction=' + this.openingDirection + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.frameProfile + '_' + this.openingDirection + '_' + this.doorRange;
            },
            panel_required(){
                return true;
            }
        },
        watch: {
            'frameProfile': function (val, oldVal) {
                this.update_options();
            },
            'openingDirection': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
